/**
 * Device Compatibility Data
 * Contains supported and unsupported device lists for eSIM compatibility checking
 */
window.deviceCompatibilityData = {
  "Supported": {
    "Apple": [
      "iPhone XR",
      "iPhone XS",
      "iPhone XS Max",
      "iPhone 11",
      "iPhone 11 Pro",
      "iPhone 11 Pro Max",
      "iPhone SE (2nd generation)",
      "iPhone SE (3rd generation)",
      "iPhone 12",
      "iPhone 12 Mini",
      "iPhone 12 Pro",
      "iPhone 12 Pro Max",
      "iPhone 13",
      "iPhone 13 Mini",
      "iPhone 13 Pro",
      "iPhone 13 Pro Max",
      "iPhone 14",
      "iPhone 14 Plus",
      "iPhone 14 Pro",
      "iPhone 14 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16e",
      "iPhone 17",
      "iPhone 17e",
      "iPhone Air",
      "iPhone 17 Pro",
      "iPhone 17 Pro Max",
      "iPhone 18 Pro",
      "iPhone 18 Pro Max",
      "iPad (7th generation)",
      "iPad (8th generation)",
      "iPad (9th generation)",
      "iPad (10th generation)",
      "iPad (A16)",
      "iPad Air (3rd generation)",
      "iPad Air (4th generation)",
      "iPad Air (5th generation)",
      "iPad Air (M2)",
      "iPad Pro 11-inch (1st generation)",
      "iPad Pro 11-inch (2nd generation)",
      "iPad Pro 11-inch (3rd generation)",
      "iPad Pro 11-inch (4th generation)",
      "iPad Pro 12.9-inch (3rd generation)",
      "iPad Pro 12.9-inch (4th generation)",
      "iPad Pro 12.9-inch (5th generation)",
      "iPad Pro 12.9-inch (6th generation)",
      "iPad Pro (M4)",
      "iPad Pro 11-inch (M5)",
      "iPad Pro 13-inch (M5)",
      "iPad Mini (5th generation)",
      "iPad Mini (6th generation)",
      "iPad Mini (7th generation)",
      "iPad Air 11-inch (M3)",
      "iPad Air 13-inch (M3)",
      "iPad Air 11-inch (M4)",
      "iPad Air 13-inch (M4)"
    ],
    "Samsung": [
      "Galaxy S20",
      "Galaxy S20+",
      "Galaxy S20 Ultra",
      "Galaxy S21",
      "Galaxy S21+",
      "Galaxy S21 Ultra",
      "Galaxy S22",
      "Galaxy S22+",
      "Galaxy S22 Ultra",
      "Galaxy S23",
      "Galaxy S23+",
      "Galaxy S23 Ultra",
      "Galaxy S23 FE",
      "Galaxy S24",
      "Galaxy S24+",
      "Galaxy S24 Ultra",
      "Galaxy S24 FE",
      "Galaxy S25",
      "Galaxy S25+",
      "Galaxy S25 Ultra",
      "Galaxy S25 Edge",
      "Galaxy S25 FE",
      "Galaxy S25 Slim",
      "Galaxy S26",
      "Galaxy S26+",
      "Galaxy S26 Ultra",
      "Galaxy Note 20",
      "Galaxy Note 20 Ultra",
      "Galaxy Fold",
      "Galaxy Z Flip",
      "Galaxy Z Flip 5G",
      "Galaxy Z Flip3 5G",
      "Galaxy Z Flip4",
      "Galaxy Z Flip5 5G",
      "Galaxy Z Flip6 5G",
      "Galaxy Z Fold2 5G",
      "Galaxy Z Fold3 5G",
      "Galaxy Z Fold4",
      "Galaxy Z Fold5 5G",
      "Galaxy Z Fold6 5G",
      "Galaxy Z Flip7",
      "Galaxy Z Flip7 FE",
      "Galaxy Z Fold7",
      "Galaxy Z Flip8",
      "Galaxy Z Fold8",
      "Galaxy Z Fold8 Ultra",
      "Galaxy A54 5G",
      "Galaxy A55 5G",
      "Galaxy A35",
      "Galaxy A56",
      "Galaxy A56 5G",
      "Galaxy A36",
      "Galaxy A36 5G",
      "Galaxy A16 5G",
      "Galaxy A17 5G",
      "Galaxy A23 5G",
      "Galaxy A26 5G",
      "Galaxy A35",
      "Galaxy XCover 7",
      "Galaxy XCover 7 Pro",
      "Galaxy XCover7 Pro",
      "Galaxy Z TriFold",
      "Galaxy Tab S9",
      "Galaxy Tab S9+",
      "Galaxy Tab S9 Ultra",
      "Galaxy Tab S9 FE",
      "Galaxy Tab S9 FE+",
      "Galaxy Tab S10",
      "Galaxy Tab S10+",
      "Galaxy Tab S10 Ultra",
      "Galaxy Tab S10 FE 5G",
      "Galaxy Tab S11",
      "Galaxy Tab S11 5G",
      "Galaxy Tab S11+",
      "Galaxy Tab S11 Ultra",
      "Galaxy Tab S11 Ultra 5G"
    ],
    "Google": [
      "Pixel 3",
      "Pixel 3 XL",
      "Pixel 3a",
      "Pixel 3a XL",
      "Pixel 4",
      "Pixel 4 XL",
      "Pixel 4a",
      "Pixel 4a 5G",
      "Pixel 5",
      "Pixel 5a",
      "Pixel 6",
      "Pixel 6a",
      "Pixel 6 Pro",
      "Pixel 7",
      "Pixel 7a",
      "Pixel 7 Pro",
      "Pixel 8",
      "Pixel 8a",
      "Pixel 8 Pro",
      "Pixel 9",
      "Pixel 9a",
      "Pixel 9 Pro",
      "Pixel 9 Pro XL",
      "Pixel 9 Pro Fold",
      "Pixel 10",
      "Pixel 10a",
      "Pixel 10 Pro",
      "Pixel 10 Pro XL",
      "Pixel 10 Pro Fold",
      "Pixel 11",
      "Pixel 11 Pro",
      "Pixel 11 Pro XL",
      "Pixel 11 Pro Fold",
      "Pixel Fold"
    ],
    "Huawei": [
      "P40",
      "P40 Pro",
      "Mate 40 Pro",
      "Pura 70 Pro",
      "Pura 80",
      "Pura 80 Pro",
      "Pura 80 Ultra",
      "Pura X Max"
    ],
    "Xiaomi": [
      "12T Pro",
      "13",
      "13 Lite",
      "13 Pro",
      "13T",
      "13T Pro",
      "14",
      "14 Pro",
      "14T",
      "14T Pro",
      "15",
      "15 Pro",
      "15 Ultra",
      "15S Pro",
      "15T Pro",
      "17",
      "17 Ultra",
      "17T",
      "17T Pro",
      "Redmi Note 13 Pro+",
      "Redmi Note 13 Pro",
      "Redmi Note 14 Pro",
      "Redmi Note 14 Pro+",
      "Poco X7",
      "Poco X7 Pro"
    ],
    "Motorola": [
      "Razr 2019",
      "Razr 5G",
      "Razr 2022",
      "Razr 40",
      "Razr 40 Ultra",
      "Razr+",
      "Razr (2024)",
      "Razr+ (2024)",
      "Razr 50",
      "Razr 50 Ultra",
      "Razr 60",
      "Razr 60 Ultra",
      "Razr 70",
      "Razr 70 Plus",
      "Razr 70 Ultra",
      "Razr (2026)",
      "Razr+ (2026)",
      "Razr Ultra (2026)",
      "Edge 2022",
      "Edge 2023",
      "Edge+ (2023)",
      "Edge (2024)",
      "Edge 40",
      "Edge 40 Pro",
      "Edge 40 Neo",
      "Edge 50",
      "Edge 50 Pro",
      "Edge 50 Ultra",
      "Edge 50 Fusion",
      "Edge 50 Neo",
      "Edge 60",
      "Edge 60 Pro",
      "Edge 60 Fusion",
      "Edge 60 Stylus",
      "Edge 70",
      "Edge 70 Max",
      "Edge (2026)",
      "ThinkPhone 25",
      "Moto G75",
      "Moto G Power 5G (2024)",
      "Moto G Power (2025)",
      "G52J 5G",
      "G52J 5G II",
      "G53J 5G",
      "G53",
      "G54",
      "G84",
      "G85",
      "G34",
      "G35",
      "Moto G Stylus 5G (2024)",
      "Moto G Stylus 5G (2025)",
      "Moto G Stylus (2026)",
      "Moto G (2024)",
      "Moto G (2025)",
      "Moto G (2026)",
      "Moto G56",
      "Moto G86",
      "Moto G86 Power"
    ],
    "Oppo": [
      "Find X3",
      "Find X3 Pro",
      "Find X5",
      "Find X5 Pro",
      "Find X6",
      "Find X6 Pro",
      "Find X7",
      "Find X7 Ultra",
      "Find X8",
      "Find X8 Pro",
      "Find N2",
      "Find N2 Flip",
      "Find N3",
      "Find N3 Flip",
      "Find N5",
      "Find N5 Flip",
      "Find N6",
      "Find X9",
      "Find X9 Pro",
      "Find X9 Ultra",
      "Reno 5A",
      "Reno 6 Pro 5G",
      "Reno 9A",
      "Reno 10 Pro+",
      "Reno 11 Pro",
      "Reno 12 Pro",
      "Reno 13",
      "Reno 13 Pro",
      "Reno 15",
      "Reno 15 Pro",
      "A55s 5G"
    ],
    "Sony": [
      "Xperia 10 III Lite",
      "Xperia 10 IV",
      "Xperia 10 V",
      "Xperia 1 IV",
      "Xperia 1 V",
      "Xperia 1 VI",
      "Xperia 1 VII",
      "Xperia 5 IV",
      "Xperia 5 V",
      "Xperia 10 VI",
      "Xperia 10 VII",
      "Xperia Ace III"
    ],
    "Honor": [
      "Magic 3",
      "Magic 3 Pro",
      "Magic 3 Pro+",
      "Magic 4 Pro",
      "Magic 5 Pro",
      "Magic 6 Pro",
      "Magic 7",
      "Magic 7 Lite",
      "Magic 7 Pro",
      "Magic 8 Pro",
      "Magic 8 Lite",
      "Magic V2",
      "Magic V3",
      "Magic V5",
      "Magic Vs",
      "Magic Vs3",
      "90",
      "X8",
      "200",
      "200 Pro",
      "400",
      "400 Pro",
      "400 Lite"
    ],
    "Vivo": [
      "X80 Pro",
      "X90 Pro",
      "X100 Pro",
      "V29",
      "V29 Lite",
      "V29 Lite 5G",
      "V30 Pro",
      "V40",
      "V40 Lite",
      "V40 SE",
      "X100 Pro+",
      "X200",
      "X200s",
      "X200 Pro",
      "X200 Ultra",
      "X200 FE",
      "X300",
      "X300 Pro"
    ],
    "OnePlus": [
      "OnePlus Open",
      "OnePlus 11",
      "OnePlus 12",
      "OnePlus 13",
      "OnePlus 12R",
      "OnePlus 13R",
      "OnePlus 13T",
      "OnePlus 15"
    ],
    "Nokia": ["XR21", "X30", "G60 5G"],
    "HMD": ["Fusion", "Fusion X1", "Skyline", "Fuse"],
    "Sharp": [
      "sense4 lite",
      "Sense6s",
      "sense 7",
      "sense 7plus",
      "Wish",
      "wish 2 SHG08",
      "wish3",
      "zero 6",
      "R7",
      "R8",
      "R8 Pro",
      "sense8"
    ],
    "Rakuten": ["Mini", "Big", "Big-S", "Hand", "Hand 5G"],
    "Nothing": [
      "Phone (1)",
      "Phone (2)",
      "Phone (2a)",
      "Phone (2a) Plus",
      "Phone (3)",
      "Phone (3a)",
      "Phone (3a) Pro",
      "Phone (4a) Pro"
    ],
    "Realme": [
      "GT 2 Pro",
      "GT 3",
      "GT 5 Pro",
      "GT 6",
      "GT 6T",
      "GT 7 Pro",
      "12 Pro+",
      "13 Pro+",
      "Narzo 70 Pro",
      "14 Pro+",
      "GT 7"
    ],
    "ASUS": [
      "Zenfone 8",
      "Zenfone 9",
      "Zenfone 10",
      "Zenfone 11 Ultra",
      "Zenfone 12 Ultra",
      "ROG Phone 7",
      "ROG Phone 7 Ultimate",
      "ROG Phone 8",
      "ROG Phone 8 Pro",
      "ROG Phone 9",
      "ROG Phone 9 Pro",
      "ROG Phone 9 Pro Edition"
    ],
    "Other": [
      "Gemini PDA",
      "Fairphone 4",
      "Fairphone 5",
      "The Fairphone (Gen. 6)",
      "The Fairphone (Gen. 6+)",
      "DOOGEE V30",
      "HAMMER Blade 3",
      "HAMMER Explorer PRO",
      "HAMMER Blade 5G",
      "myPhone NOW eSIM",
      "OUKITEL WP30 Pro",
      "OUKITEL WP33 Pro",
      "Nuu X5",
      "ZTE Nubia Flip",
      "ZTE Nubia Z60 Ultra",
      "TCL 50 5G",
      "TCL 40 NxtPaper 5G",
      "TCL NXTPAPER 60 Ultra",
      "TCL NXTPAPER 70 Pro",
      "Surface Pro X",
      "Surface Pro 7+ with LTE",
      "Surface Pro 8 with LTE",
      "Surface Pro 9 with 5G",
      "Surface Pro 10 with 5G",
      "Surface Pro 11th Edition with 5G",
      "Surface Go 2 with LTE",
      "Surface Go 3 with LTE",
      "Surface Duo",
      "Surface Duo 2",
      "Light Phone 3",
      "TCL Flip 4 5G",
      "TCL 50 SE 5G"
    ]
  },
  "Exceptions": {
    "Apple": "iPhones from China mainland (except iPhone Air) or Hong Kong/Macao do not support eSIM.",
    "Samsung": "Some regional variants (China, US carrier-locked) may not support eSIM. Check for EID in Settings.",
    "Google": "Pixel 3/3a from Australia, Taiwan, Japan, or Southeast Asia may not support eSIM."
  },
  "Unsupported": {
    "Apple": [
      "iPhone 4",
      "iPhone 4s",
      "iPhone 5",
      "iPhone 5c",
      "iPhone 5s",
      "iPhone 6",
      "iPhone 6 Plus",
      "iPhone 6s",
      "iPhone 6s Plus",
      "iPhone SE (1st generation)",
      "iPhone 7",
      "iPhone 7 Plus",
      "iPhone 8",
      "iPhone 8 Plus"
    ],
    "Samsung": [
      "Galaxy S",
      "Galaxy S2",
      "Galaxy S3",
      "Galaxy S4",
      "Galaxy S5",
      "Galaxy S6",
      "Galaxy S6 Edge",
      "Galaxy S7",
      "Galaxy S7 Edge",
      "Galaxy S8",
      "Galaxy S8+",
      "Galaxy S9",
      "Galaxy S9+",
      "Galaxy Note",
      "Galaxy Note II",
      "Galaxy Note 3",
      "Galaxy Note 4",
      "Galaxy Note 5",
      "Galaxy Note 7",
      "Galaxy Note 8",
      "Galaxy Note 9",
      "Galaxy A series (models before A54)",
      "Galaxy J series",
      "Galaxy M series"
    ],
    "Google": [
      "Nexus One",
      "Nexus S",
      "Galaxy Nexus",
      "Nexus 4",
      "Nexus 5",
      "Nexus 5X",
      "Nexus 6",
      "Nexus 6P",
      "Pixel",
      "Pixel XL",
      "Pixel 2",
      "Pixel 2 XL"
    ],
    "Huawei": [
      "Ascend series",
      "P series (models before P40)",
      "Mate series (models before Mate 40 Pro)",
      "Honor series (models before Magic 3)"
    ],
    "Xiaomi": [
      "Mi series (models before Mi 12T Pro)",
      "Redmi series (models before Redmi Note 13 Pro+)",
      "Poco series (models before Poco X7)"
    ],
    "OnePlus": [
      "OnePlus One",
      "OnePlus 2",
      "OnePlus X",
      "OnePlus 3",
      "OnePlus 3T",
      "OnePlus 5",
      "OnePlus 5T",
      "OnePlus 6",
      "OnePlus 6T",
      "OnePlus 7",
      "OnePlus 7 Pro",
      "OnePlus 7T",
      "OnePlus 7T Pro",
      "OnePlus 8",
      "OnePlus 8 Pro",
      "OnePlus 8T",
      "OnePlus 9",
      "OnePlus 9 Pro",
      "OnePlus 9R",
      "OnePlus 9RT",
      "OnePlus 10 Pro",
      "OnePlus 10T",
      "OnePlus 10R",
      "OnePlus Nord series (most models)"
    ],
    "Sony": [
      "Xperia Z series",
      "Xperia X series",
      "Xperia XA series",
      "Xperia L series",
      "Xperia M series",
      "Xperia E series",
      "Xperia C series"
    ],
    "LG": [
      "Optimus series",
      "G series",
      "V series",
      "K series",
      "Q series",
      "Velvet",
      "Wing"
    ],
    "Motorola": [
      "Moto G series (models before G52J 5G)",
      "Moto E series",
      "Moto X series",
      "Moto Z series"
    ],
    "Nokia": [
      "Nokia N8",
      "Nokia Lumia series",
      "Nokia 3310 (2017)",
      "Nokia 5230",
      "Nokia 105 (2019)",
      "Nokia 110 (2019)",
      "Nokia 220 4G",
      "Nokia 2660 Flip",
      "Nokia 5710 XpressAudio",
      "Nokia 8210 4G"
    ],
    "HTC": [
      "HTC One M7",
      "HTC One M8",
      "HTC One M9",
      "HTC 10",
      "HTC U11",
      "HTC U12+"
    ],
    "BlackBerry": [
      "BlackBerry Bold series",
      "BlackBerry Curve series",
      "BlackBerry Z10",
      "BlackBerry Q10",
      "BlackBerry Passport",
      "BlackBerry Priv",
      "BlackBerry KEYone",
      "BlackBerry KEY2"
    ],
    "Nothing": [
      "All Nothing phones support eSIM"
    ],
    "Realme": [
      "Realme 1 through 11 series (non-Pro+ models)",
      "Realme C series",
      "Realme Narzo series (models before Narzo 70 Pro)",
      "Realme GT (original)",
      "Realme GT Neo series",
      "Realme GT Master Edition"
    ],
    "ASUS": [
      "ZenFone series (models before ZenFone 8)",
      "ROG Phone series (models before ROG Phone 7)"
    ],
    "Others": [
      "Alcatel One Touch series",
      "ZTE Axon series (models before Axon 30)",
      "Lenovo K series",
      "Micromax Canvas series",
      "Infinix Zero series",
      "Tecno Camon series",
      "Vivo V series (models before V29)"
    ]
  }
};